<template>
    <div class="list-group border-radius-2 no-border">
        <div class="list-group-item">
            <SelectInput
                v-model="group_id"
                :options="groups"
                optionLabel="title"
                optionValue="id"
                :label="$t('select-a-group')"
                :srOnly="true"
                :nullLabel="$t('select-a-group')"
                class="mb-0"
            />
        </div>
        <ScrollPaginator
            :data="filteredOutcomes"
            :submitting="loading"
            :filters=filters
        >
            <template v-slot:item="{ item: outcome }">
                <div
                    @click="toggleOutcome(outcome)"
                    class="list-group-item"
                    :class="{ 'bg-light': value.findIndex(el => el.id === outcome.id) > -1 }"
                >
					<template v-if="outcome.code">{{ outcome.code }}: </template>
                    {{ outcome.title }}
                </div>
            </template>
        </ScrollPaginator>
    </div>
</template>

<script>
import ScrollPaginator from '../Table/ScrollPaginator.vue'
import SelectInput from '../Inputs/SelectInput.vue'

export default {
    components: {
        ScrollPaginator,
        SelectInput,
    },
    props: {
        value: Array,
    },
    mounted() {
        Promise.all([this.fetchOutcomes(), this.fetchGroups()]).then(() => {
            this.loading = false
        })
    },
    data() {
        return {
            groups: [],
            outcomes: [],
            group_id: undefined,
            loading: true,
            filters: {
                page: 1,
                page_size: 1000,
                total: 0,
            }
        }
    },
    methods: {
        fetchOutcomes() {
            this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/list`, {
                method: 'GET',
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching learning outcomes')

                this.outcomes = res.results;
                this.filters.page_size = res.pagination.total
                this.filters.total = res.pagination.total
            }).catch(err => {
                console.error(err);
                this.$log.error.call(this, err);
            })
        },
        fetchGroups() {
            this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/group/list`, {
                method: 'GET',
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching learning outcomes')

                this.groups = res.results;
            }).catch(err => {
                console.error(err);
                this.$log.error.call(this, err);
            })
        },
        toggleOutcome(outcome) {
            const index = this.value.findIndex(el => el.id == outcome.id)
            if (index > -1) this.$emit('input', this.value.filter(el => el.id !== outcome.id))
            else this.$emit('input', [...this.value, outcome])
        }
    },
    computed: {
        filteredOutcomes() {
            if (!this.group_id) return this.outcomes

            return this.outcomes.filter(el => el.learningoutcomegroup_id === this.group_id)
        }
    }
}
</script>
